import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/home")({
  component: Home,
});

function Home() {
  return (
    <main className="page-wrap pb-10">
      <section className="island-shell rise-in rounded-md py-8 px-7 mb-6">
        <p className="island-kicker mb-2">Financial Management</p>
        <h1 className="display-title text-4xl mb-3 max-w-[700px]">
          Track your finances with precision.
        </h1>
        <p className="m-0 max-w-[640px] text-[0.9375rem] leading-relaxed text-[--ink-soft]">
          Open Money provides a clean, data-focused interface for managing your financial accounts.
          Connect banks via Plaid, track balances, and maintain a clear view of your finances.
        </p>
      </section>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5">
        <Link to="/bank_accounts" className="no-underline">
          <article className="feature-card rounded-md p-5 h-full">
            <div className="text-[1.75rem] text-[--green] mb-2.5 opacity-70">⚖</div>
            <h3 className="text-[1.0625rem] mb-2">Bank Accounts</h3>
            <p className="text-[--ink-soft] text-sm leading-normal m-0">
              Create and manage financial accounts. Track balances and organize your finances.
            </p>
          </article>
        </Link>

        <Link to="/plaid_accounts" className="no-underline">
          <article className="feature-card rounded-md p-5 h-full">
            <div className="text-[1.75rem] text-[--green] mb-2.5 opacity-70">🏦</div>
            <h3 className="text-[1.0625rem] mb-2">Connected Banks</h3>
            <p className="text-[--ink-soft] text-sm leading-normal m-0">
              Link financial institutions via Plaid. Synchronize transactions and balances.
            </p>
          </article>
        </Link>

        <Link to="/connect" className="no-underline">
          <article className="feature-card rounded-md p-5 h-full">
            <div className="text-[1.75rem] text-[--green] mb-2.5 opacity-70">✦</div>
            <h3 className="text-[1.0625rem] mb-2">Connect New Bank</h3>
            <p className="text-[--ink-soft] text-sm leading-normal m-0">
              Add new financial institutions. Expand your financial overview with secure
              connections.
            </p>
          </article>
        </Link>
      </div>
    </main>
  );
}
